import script from "./ODadosGrupo.vue?vue&type=script&lang=ts&setup=true"
export * from "./ODadosGrupo.vue?vue&type=script&lang=ts&setup=true"

import "./ODadosGrupo.vue?vue&type=style&index=0&id=523d02cf&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-523d02cf"]])

export default __exports__